export default "__VITE_ASSET___KfNn6Hd__"